<template>
  <div
    class="toast-container pointer-events-none fixed z-50 flex flex-col gap-2"
    :class="positionStyles"
  >
    <TransitionGroup name="toaster" tag="div" class="flex flex-col gap-2">
      <Toast
        v-for="toast in toasts"
        role="alert"
        v-bind="toast"
        :key="toast.id"
        @close="$emit('close', toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import type { ToastProps } from "~/types/schemas/common/Atom/toaster";
import Toast from "./Toast/index.vue";

const props = defineProps<{
  toasts: ToastProps[];
}>();

defineEmits<{
  (e: "close", id: number): void;
}>();

const positionMap: Record<string, string> = {
  "top-left": "top-12 left-9",
  "top-right": "top-12 right-9",
  "bottom-left": "bottom-9 left-9",
  "bottom-right": "bottom-9 right-9",
  "top-center": "top-12 left-1/2 transform -translate-x-1/2",
  "bottom-center": "bottom-9 left-1/2 transform -translate-x-1/2",
};

const positionStyles = computed(
  () =>
    positionMap[props.toasts[props.toasts.length - 1]?.position ?? "top-right"],
);
</script>

<style scoped>
.toaster-enter-active,
.toaster-leave-active {
  transition: all 350ms ease-in-out;
}

.toaster-enter-from,
.toaster-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

&:where([dir="rtl"], [dir="rtl"] *) {
  .toaster-enter-from,
  .toaster-leave-to {
    opacity: 0;
    transform: translateX(-100%);
  }
}
</style>
